export default "__VITE_ASSET__b3f59cc4__"